// extracted by mini-css-extract-plugin
export default {"main_nav":"index_main_nav_veud1","user":"index_user_KeFQE","box":"index_box_V8OAF","ad":"index_ad_-7Gkt","search":"index_search_UMuSr","logo":"index_logo_6o-K1"};